import { normalizeInboxNotifications } from '@/lib/adapters/notifications.adapter'
import { notificationRequest } from '@/lib/services'
import { novuInstance } from '@/lib/services/novu.services'

export const getNotifications = async (subscriberId: string, page = 1, read?: boolean) => {
  const response = await novuInstance.notifications.list({
    limit: 10,
    offset: (page - 1) * 10,
    read,
    archived: false,
    useCache: false,
  })
  if (response.error) {
    throw response.error
  }
  if (!response.data) {
    throw new Error('Novu returned no notifications')
  }

  return {
    data: normalizeInboxNotifications(response.data.notifications, subscriberId),
    hasMore: response.data.hasMore,
  }
}

export const updateNotificationReadStatus = async (
  subscriberId: string,
  notificationId: string,
  status: 'read' | 'unread',
) => {
  await notificationRequest.put(
    `/subscribers/${subscriberId}/notifications/${notificationId}/read-status`,
    { status },
  )
}

export const markAllNotificationsAsRead = async (subscriberId: string) => {
  await notificationRequest.put(`/subscribers/${subscriberId}/notifications/read-all`, {})
}
